import { CommonModule } from '@angular/common';
import { Component, HostBinding, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { userRoleType } from '@core/models';
import { setShowSidebar, setToggleSidebar } from '@core/store/actions';
import { Store } from '@ngrx/store';
import { selectCoreShowSidebar } from '@store/selectors/core.selector';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';

@Component({
  standalone: true,
  imports: [CommonModule, SidebarModule, RouterModule, NgxPermissionsModule, ButtonModule],
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent implements OnInit {
  @HostBinding('class.show-sidebar') showSidebar = false;

  roles = userRoleType;
  hideContent = false;

  constructor(
    private readonly store: Store,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.store.select(selectCoreShowSidebar).subscribe((value: boolean) => {
      this.showSidebar = value;
    });

    // fix on small screens, the menu remains open after clicking on some item
    this.router.events.subscribe({
      next: () => {
        if (window.innerWidth < 768 && this.showSidebar === true) this.handleShowSidebar(false);
      },
    });

    this.hideSidebar();
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.hideSidebar();
  }

  // Double validation to avoid saving in the store at each screen resize
  hideSidebar() {
    if (window.innerWidth < 768 && this.showSidebar === true) this.handleShowSidebar(false);
    if (window.innerWidth > 768 && this.showSidebar === false) this.handleShowSidebar(true);
  }

  handleShowSidebar(value: boolean) {
    this.store.dispatch(setShowSidebar({ value }));
  }

  toggleSidebar() {
    this.store.dispatch(setToggleSidebar());
  }
}
